export default "assets/images/logo-e5cd08d4.svg";